import React, { useState, useEffect } from "react";
import { useLazyOrdergetQuery } from "../../redux/Api/api";

const Orderpage = ({ stateData }) => {
  console.log("stateData:", stateData);

  const [orderDetails, setOrderDetails] = useState(null);
  const [orderget] = useLazyOrdergetQuery();

  useEffect(() => {
    if (stateData?.order?._id) {
      orderget(stateData.order._id)
        .unwrap()
        .then((res) => {
          console.log("✅ Order viewed successfully:", res);
          setOrderDetails(res.order);
        })
        .catch((err) => {
          console.error(" Order fetch error:", err);
        });
    }
  }, [stateData]);

  console.log("✅ Final Order Data:", orderDetails);

  return (
    <div className="max-w-7xl mx-auto mt-40 p-6 md:p-14 bg-white shadow-lg rounded-md">
      <h1 className="text-3xl font-bold text-center">Your Order Details</h1>
      {!orderDetails ? (
        <p className="text-gray-500 text-center mt-4">Loading order details...</p>
      ) : (
        <>
          <p className="text-gray-600 mt-2 text-center">
            Hello, {orderDetails?.user?.name || "Guest"}
          </p>

          <div className="bg-gray-100 p-6 mt-8 rounded-md">
            <h2 className="text-xl font-semibold mb-4 text-left">Order Summary</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-left">
              <div>
                <p className="text-gray-600">Order date:</p>
                <p className="font-semibold">
                  {new Date(orderDetails?.orderedAt).toLocaleString() || "N/A"}
                </p>
              </div>
              <div>
                <p className="text-gray-600">Order status:</p>
                <p className="font-semibold">
                  {orderDetails?.status === "pending" ? "Pending " : "Confirmed "}
                </p>
              </div>
              <div>
                <p className="text-gray-600">Total order amount:</p>
                <p className="font-semibold">₹{orderDetails?.totalPrice || "N/A"}</p>
              </div>
              <div>
                <p className="text-gray-600">Phone Number:</p>
                <p className="font-semibold">{orderDetails?.user?.phone || "N/A"}</p>
              </div>
              <div>
                <p className="text-gray-600">Shipping Address:</p>
                <p className="font-semibold">
                  {orderDetails?.shippingAddress?.address}, {orderDetails?.shippingAddress?.city},
                  {orderDetails?.shippingAddress?.state} - {orderDetails?.shippingAddress?.pincode}
                </p>
              </div>
              <div>
                <p className="text-gray-600">Payment method:</p>
                <p className="font-semibold">
                  {orderDetails?.cashOnDelivery ? "Cash on Delivery" : "Online Payment"}
                </p>
              </div>
            </div>
          </div>

          <div className="mt-8 border-t border-gray-300 pt-8">
            {orderDetails?.cartItems?.map((item, index) => (
              <div key={index} className="flex items-center justify-between gap-6 mt-6 p-4 bg-gray-50 rounded-lg shadow">
                {/* Product Image */}
                <div className="flex items-center gap-4">
                  <img
                    src={item.product?.image}
                    alt={item.product.name}
                    className="w-28 h-28 object-cover rounded-lg shadow-md" // Increased size
                  />

                  {/* Product Details (Left Side) */}
                  <div className="text-left">
                    <p className="font-semibold text-lg">{item.product.name}</p>
                    <p className="text-gray-600">Quantity: {item.quantity}</p>
                  </div>
                </div>

                {/* Price (Right Side) */}
                <p className="text-xl font-bold text-gray-800">₹{item.product.price}</p>
              </div>
            ))}
          </div>


          {/* Total Price Section */}
          <div className="mt-8 border-t border-gray-300 pt-8">
            <div className="flex justify-between text-2xl font-bold mt-6">
              <p>Total</p>
              <p>₹{orderDetails?.totalPrice}</p>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Orderpage;
